export default __webpack_public_path__ + "static/media/clay.0a1391ba.png";